import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {ellipsis} from '../../../../libs/shared/ui/src/styles/mixins';

/*
 * Props.
 */

interface InfoBubbleStepCounterProps {}

/*
 * Style.
 */

const StyledDiv = styled.div`
  flex: 1 0;
  color: ${(p) => p.theme.greys.shade60};
  font-size: ${fontSizes.medium};
  font-weight: ${fontWeights.semibold};
  line-height: 16px;
  padding: 7px 0;
  ${ellipsis()}
`;

/*
 * Component.
 */

export const InfoBubbleStepCounter: FC<PropsWithChildren<InfoBubbleStepCounterProps>> = (props) => {
  const {children} = props;
  return <StyledDiv>{children}</StyledDiv>;
};
